module.exports = __webpack_public_path__ + "static/media/icon_event_assist.2e1b4677.svg";